'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

type AppRouter = ReturnType<typeof useRouter>;

let appRouter: AppRouter | null = null;

export function setAppRouter(router: AppRouter | null): void {
  appRouter = router;
}

export function getAppRouter(): AppRouter | null {
  return appRouter;
}

/**
 * Bridges Next.js App Router into a module-level singleton so non-React modules
 * (WebSocket handlers, services) can issue SPA navigations via `getAppRouter()?.push(...)`
 * instead of `window.location.href` (which forces a full reload).
 */
export function AppRouterBridge() {
  const router = useRouter();

  useEffect(() => {
    setAppRouter(router);
    return () => setAppRouter(null);
  }, [router]);

  return null;
}
